import { FC, useEffect, useState } from "react";
// Hooks
import useNavigateTo from "hooks/useNavigateTo";
import { useAppDispatch, useAppSelector } from "hooks/useStore";
// Redux
import { setPageIndex } from "store/pages/pagesSlice";
import { selectPage, selectPageIndex } from "store/pages/pagesSelectors";
import PageTypes from "types/PageTypes";
import Paths from "types/Paths";
 
const PageHandler:FC = () => {
  const dispatch = useAppDispatch();
  const pageIndex = useAppSelector(selectPageIndex);
  const page = useAppSelector(selectPage);

  const [rendered, setRendered] = useState(false);

  const navigateTo = useNavigateTo();

  const paths:Record<PageTypes, Paths> = {
    [PageTypes.Banner]: 'media',
    [PageTypes.Question]: 'question',
    [PageTypes.AdditionalQuestions]: 'additionalQuestions',
    [PageTypes.Timer]: 'timer',
    [PageTypes.Waiting]: 'waiting'
  }

  useEffect(() => {
    if (!rendered) return;
    if (!page && pageIndex > 0) navigateTo('register');
    if (!page) return;
    
    navigateTo(paths[page.type]);
    // eslint-disable-next-line
  }, [page, rendered]);

  useEffect(() => {
    dispatch(setPageIndex(pageIndex + 1));
    setRendered(true);
    return () => {
      setRendered(false);
    }
    // eslint-disable-next-line
  }, []);

  return null;
}
 
export default PageHandler;